import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '@/App';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { User, Mail, IdCard, Phone, ArrowLeft } from 'lucide-react';

export default function PersonalData() {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (!user || user.user_type !== 'client') {
      navigate('/client/login');
    }
  }, [user, navigate]);

  if (!user || user.user_type !== 'client') return null;

  // Somente leitura: exibir apenas dados que realmente existem no usuário autenticado.
  const cpf = user.cpf || user.cpf_cnpj || null;
  const phone = user.phone || user.telefone || user.whatsapp || null;

  const fields = [
    { key: 'name', label: 'Nome', value: user.name, icon: User },
    { key: 'email', label: 'E-mail', value: user.email, icon: Mail },
    { key: 'cpf', label: 'CPF', value: cpf, icon: IdCard },
    { key: 'phone', label: 'Telefone', value: phone, icon: Phone },
  ].filter((f) => f.value);

  return (
    <div className="min-h-screen bg-slate-50" data-testid="page-personal-data">
      {/* Header */}
      <div className="bg-white border-b sticky top-0 z-10">
        <div className="max-w-2xl mx-auto px-4 py-4 flex items-center gap-3">
          <Button variant="ghost" size="sm" onClick={() => navigate('/client/profile')} data-testid="personal-data-back-btn">
            <ArrowLeft className="w-4 h-4" />
          </Button>
          <h1 className="text-lg font-bold" data-testid="personal-data-title">Dados pessoais</h1>
        </div>
      </div>

      <div className="max-w-2xl mx-auto px-4 py-6 space-y-3">
        {fields.map(({ key, label, value, icon: Icon }) => (
          <Card key={key} className="p-4 flex items-center gap-3" data-testid={`personal-field-${key}`}>
            <div className="bg-slate-100 p-2 rounded-full shrink-0">
              <Icon className="w-5 h-5 text-slate-700" />
            </div>
            <div className="min-w-0">
              <p className="text-xs text-muted-foreground">{label}</p>
              <p className="font-medium break-words" data-testid={`personal-value-${key}`}>{value}</p>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
